import { AvatarUpload } from "src/components/AvatarUpload/AvatarUpload";
import Avatar from "src/components/Avatar/Avatar";
import { UploadAvatarResponse } from "lens-platform-sdk/dist/cjs/UserService";
import { User } from "lens-platform-sdk";
import { useMemo } from "react";
import styles from "./ProfileAvatar.module.css";
import { getUserAvatar } from "../../../utils/user";

export interface ProfileAvatarProps {
  onAvatarUpload: (file: File) => Promise<UploadAvatarResponse | undefined>;
  loading: boolean;
  user: User;
  onAvatarError?: (error: Error) => void
}

export const ProfileAvatar = ({
  user, loading, onAvatarUpload, onAvatarError
}: ProfileAvatarProps) => {
  const avatarImage = getUserAvatar(user);
  // As avatar image URL always stays the same for the user, e.g /:userId/avatar.jpg
  // Add a random to avatar URL to force the change of newly uploaded image.
  const avatar = useMemo(() => (avatarImage && !loading ? `${avatarImage}?${Math.random() * 1000}` : undefined),
    [avatarImage, loading]);

  return (
    <div className={styles.avatarContainer}>
      <Avatar name={user.username} className={styles.profileAvatar} size="md" image={avatar} />
      <AvatarUpload
        className={styles.avatarUploadForm}
        loading={loading}
        onAvatarUpload={onAvatarUpload}
        onAvatarError={onAvatarError}
      />
    </div>
  );
};
